import { render, staticRenderFns } from "./atelier.vue?vue&type=template&id=c3c0884e&"
import script from "./atelier.vue?vue&type=script&lang=js&"
export * from "./atelier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports